import { mapState } from "vuex";
import i18n from '../../plugins/i18n';

export default {
  name: "DateTimePickerWithZone",
  props: { actDate: Object | String, noTime: Boolean, label: String, labelSeparateLine: Boolean, required: Boolean },
  extends: [this.$DatePicker],
  data() {
    return {
      date: this.$moment().format("YYYY-MM-DDTHH:mm"),
      maxDate: this.$moment().format("YYYY-MM-DDTHH:mm"),
      // No timezone offset is calculated, because this line makes Date object to string in
      // the valueType format
      valueType: "YYYY-MM-DD HH:mm",
      lang: this.$i18n.locale,
      invalid: i18n.t('editCow.errors.fieldRequired'),
      error: null,
      validate: false
    };
  },
  computed: {
    ...mapState({
      timezone(state) {
        return state.user.timezone || "UTC";
      }
    }),
  },
  async mounted() {
    try{
      this.date = this.actDate ? this.actDate.format("YYYY-MM-DD HH:mm") : null;
    } catch (e) {
      this.date = null;
    }
  },
  methods: {
    changeDate(newDate) {
      this.$emit("dateChanged", newDate);
      this.error = null;
      if (!newDate && this.required) {
        this.error = i18n.t('editCow.errors.fieldRequired');
        return;
      }
      if (newDate && (new Date(newDate)) > new Date()) {
        this.error = i18n.t('editCow.errors.dateInFuture');
        return;
      }
    }
  },
  watch: {
    actDate(newDate) {
      this.date = this.$moment(newDate).format("YYYY-MM-DD HH:mm");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_datetimepicker/datetimepicker.js